import { useQuery, QueryHookOptions, QueryResult } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { PageMetaContext } from '../context/PageMetaContext';
import { useNotNullableContext } from './useNotNullableContext';
import { useEffect } from 'react';
import { captureException } from '@sentry/browser';

export default function useFullPageQuery<TQuery>(
  query: DocumentNode,
  options: QueryHookOptions = {},
): QueryResult<TQuery> {
  const { pageType, pageShortName, isPreview } = useNotNullableContext(
    PageMetaContext,
  );
  const result = useQuery<TQuery>(query, {
    ...options,
    variables: {
      type: pageType.toUpperCase(),
      slug: pageShortName,
      preview: isPreview,
      ...options.variables,
    },
    ssr: false, // We do all our server side queries through our base page query
    errorPolicy: 'all',
    skip: typeof window === 'undefined',
  });

  useEffect(() => {
    if (result.error) {
      captureException(result.error);
    }
  }, [result.error]);

  return result;
}
